import AuthModule from './auth.module'

export default AuthModule
